import { logger } from './logger'
import type { PlanTier } from './billing'

export const PLAN_PARAM_KEYS = ['plan', 'tier', 'selected_plan', 'selectedPlan'] as const

type SearchParamsLike = {
  get: (key: string) => string | null
}

export const normalizePlanHint = (value: unknown): PlanTier | null => {
  if (typeof value !== 'string') return null
  const normalized = value.trim().toLowerCase()
  if (!normalized) return null

  if (['basic', 'starter', 'essentials', 'essential'].includes(normalized)) {
    return 'basic'
  }
  if (['professional', 'pro', 'growth'].includes(normalized)) {
    return 'professional'
  }
  if (['enterprise', 'scale', 'corporate'].includes(normalized)) {
    return 'enterprise'
  }

  return null
}

export const resolvePlanFromSearchParams = (
  searchParams?: SearchParamsLike | null
): PlanTier | null => {
  if (!searchParams) return null
  for (const key of PLAN_PARAM_KEYS) {
    const value = searchParams.get(key)
    const normalized = normalizePlanHint(value)
    if (normalized) return normalized
  }
  return null
}

export const extractPlanHintFromLocation = (): PlanTier | null => {
  if (typeof window === 'undefined') return null
  try {
    const current = new URL(window.location.href)
    return resolvePlanFromSearchParams(current.searchParams)
  } catch (error) {
    logger.warn('[Plan] No fue posible leer el plan desde la URL', { error })
  }
  return null
}
